document.addEventListener("DOMContentLoaded", (event) => {
    var accordionGroups = document.querySelectorAll(".section-accordion");

    accordionGroups.forEach((accordionGroup) => {
        var accordionItems = accordionGroup.querySelectorAll(".accordion-item");

        accordionItems.forEach((accordionItem, index) => {
            var accordionButton = accordionItem.querySelector(".accordion-item_title");
            var tabContent = accordionItem.querySelector(".accordion-item_content");

            if (index == 0) {
                accordionItem.classList.add("active");
                tabContent.style.maxHeight = tabContent.scrollHeight + "px";
            }

            accordionButton.addEventListener("click", function() {
                if (this.parentElement.classList.contains("active")) {
                    this.parentElement.classList.remove("active");
                    this.nextElementSibling.style.maxHeight = null;
                } else {
                    this.closest(".section-accordion").querySelectorAll(".accordion-item").forEach((item) => {
                            item.classList.remove("active");
                            item.querySelector(".accordion-item_content").style.maxHeight = null;
                    });

                    this.parentElement.classList.add("active");
                    this.nextElementSibling.style.maxHeight = tabContent.scrollHeight + "px";
                }
            });
        });

        window.addEventListener("resize", function() {
            accordionItems.forEach((accordionItem) => {
                var tabContent = accordionItem.querySelector(".accordion-item_content");
                if (accordionItem.classList.contains("active")) {
                    tabContent.style.maxHeight = tabContent.scrollHeight + "px";
                }
            });
        });
    });
});